// wxPay/WxPayOrderBakEdit.tsx
import WxPayOrderEditBase from './WxPayOrderEditBase';

const WxPayOrderBakEdit = (props: any) => (
    <WxPayOrderEditBase apiId="wxPayOrderBak" outerProps={props} />
);

export default WxPayOrderBakEdit;